import React, { useEffect, useState } from 'react';
import { TextField, Button, CardContent, CardHeader, Switch } from '@material-ui/core';
import GalleryField from 'components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import {
	Props,
	verticalWidgetType,
} from './types';
import {
  ColorPalette,
} from '../horizontalWidgetCard/types'
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import { WidgetInstance } from 'mobx-store/stores/customScreens/types';
import { NavigationOptions } from 'screens/addEditCustomScreen/components/navigationOptions';

const getWidgetParamsFields = (widgetType: verticalWidgetType | null, focusedWidgetData: WidgetInstance, handleChange: any) => {
	const actualWidgetType = focusedWidgetData.params.actionButtonType || widgetType;
	if (actualWidgetType === verticalWidgetType.EXTERNAL) {
		return (
			<TextField
				value={focusedWidgetData.params.actionButtonExternalLink || ''}
				onChange={(event) => handleChange('actionButtonExternalLink', event.target.value)}
				autoFocus
				margin="dense"
				id="actionButtonExternalLink"
				label="Widget External Link"
				fullWidth
			/>
		);

	}

	if (actualWidgetType === verticalWidgetType.INTENAL) {
		return (
			<>
				<NavigationOptions 
					redirect= {focusedWidgetData.params.actionButtonRedirect}
					entityId={focusedWidgetData.params.actionButtonEntityId}
					handleEntityIdChangeData= {(value: string) => handleChange('actionButtonRedirect', value) }
					handleRedirectChangeData= {(value: string) => handleChange('actionButtonEntityId', value) }
				/>
				<TextField
					value={focusedWidgetData.params.actionButtonParams || ''}
					onChange={(event) => handleChange('actionButtonParams', event.target.value)}
					autoFocus
					margin="dense"
					id="actionButtonParams"
					label="Widget Params"
					fullWidth
				/>
			</>
		);
	}
	if (actualWidgetType === verticalWidgetType.STATIC) {
		return (
			<>
				<TextField
					value={focusedWidgetData.params.actionButtonStaticTitle || ''}
					onChange={(event) => handleChange('actionButtonStaticTitle', event.target.value)}
					autoFocus
					margin="dense"
					id="actionButtonStaticTitle"
					label="Widget Static Title"
					fullWidth
				/>
				<TextField
					value={focusedWidgetData.params.actionButtonStaticDescription || ''}
					onChange={(event) => handleChange('actionButtonStaticDescription', event.target.value)}
					autoFocus
					margin="dense"
					id="actionButtonStaticDescription"
					label="Widget Static Description "
					fullWidth
				/>
			</>
		);
	}
}

const VerticalWidgetCard: React.FC<Props> = (props: Props) => {

	const [dismissButton, setDismissButton] = useState(false);

	useEffect(() => {
		props.handleMultipleChangeData({
			colorPalette: props.focusedWidgetData.params.colorPalette || ColorPalette.PRIMARY,
			actionButtonType: props.focusedWidgetData.params.actionButtonType || verticalWidgetType.INTENAL
		})
	}, [props.focusedWidgetData.widgetInstanceId])
	return (
		(
			<>
				<CardContent>
					<TextField
						value={props.focusedWidgetData.params.title}
						onChange={(event) => props.handleChangeData('title', event.target.value)}
						autoFocus
						margin="dense"
						id="widgetTitle"
						label="Widget Title"
						fullWidth
					/>
					<TextField
						value={props.focusedWidgetData.params.description}
						onChange={(event) => props.handleChangeData('description', event.target.value)}
						autoFocus
						margin="dense"
						id="widgetDescription"
						label="Widget Description"
						fullWidth
					/>
					<GalleryField
						errors=""
						touched=""
						filedType="GalleryField"
						onAddImage={(name, image) => {
							props.handleChangeData('imageURL', URL.createObjectURL(image))
						}}
						onRemoveImage={() => {
							props.handleChangeData('imageURL', '')
						}}
						name="widgetImage"
						value={props.focusedWidgetData.params.imageURL ? [{ imageUrl: props.focusedWidgetData.params.imageURL }] : []}
						accept="image/*"
						size={200}
						label="Widget Image"
						isLimitToOneImage
					/>
					{
						props.focusedWidgetData.params.colorPalette && 
						<SearchFilterDropdown
						label={'Color Palette'}
						searchFilterDropdown={{
							filters: Object.entries(ColorPalette).map((type) => ({ value: type[1], name: type[0] })),
							value: props.focusedWidgetData.params.colorPalette,
							onChange: (status: ColorPalette) => {
								props.handleChangeData('colorPalette', status);
							}
						}}
					/>
					}
					
					<span>Dismiss Button</span>
					<Switch
						checked={ props.focusedWidgetData.params.dismissButton === 'true' || dismissButton}
						onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setDismissButton(event.target.checked);
							props.handleChangeData('dismissButton', event.target.checked.toString());
						}}
						name="dismissButton"
					/>
					{
						props.focusedWidgetData.params.actionButtonType && 
						<SearchFilterDropdown
						label={'Widget Type'}
						searchFilterDropdown={{
							filters: Object.entries(verticalWidgetType).map((type) => ({ value: type[1], name: type[0] })),
							value: props.focusedWidgetData.params.actionButtonType || '',
							onChange: (status: verticalWidgetType) => {
								props.handleChangeData('actionButtonType', status);
							}
						}}
					/>
					}
				
					<TextField
						value={props.focusedWidgetData.params.actionButtonTitle || ''}
						onChange={(event) => props.handleChangeData('actionButtonTitle', event.target.value)}
						autoFocus
						margin="dense"
						id="actionButtonTitle"
						label="Widget Button Title "
						fullWidth
					/>
					{
						getWidgetParamsFields(props.focusedWidgetData.params.actionButtonType as verticalWidgetType, props.focusedWidgetData, props.handleChangeData)
					}
				</CardContent>
			</>
		)
	);
};

export default VerticalWidgetCard;